import React from 'react'
import rAF from '../../../util/requestAnimationFrame'
import isEqual from 'lodash/isEqual'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './horizontalScroller.css'


function indexOfClosest (num, arr) {
  let mid
  let lo = 0
  let hi = arr.length - 1
  while (hi - lo > 1) {
    mid = Math.floor ((lo + hi) / 2)
    if (arr[mid] < num) {
      lo = mid
    } else {
      hi = mid
    }
  }
  if (num - arr[lo] <= arr[hi] - num) {
    return lo
  }
  return hi
}
const getTime = Date.now || function getTime () { return new Date().getTime() }
function momentum (current, start, time, deceleration) {
  let distance = current - start,
    speed = Math.abs(distance) / time,
    destination,
    duration

  deceleration = deceleration === undefined ? 0.006 : deceleration

  destination = current + ( speed * speed ) / ( 2 * deceleration ) * ( distance < 0 ? -1 : 1 )
  duration = speed / deceleration

  return {
    destination: Math.round(destination),
    duration: duration
  }
}
function windowWidth() {
  const w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName('body')[0],
    x = w.innerWidth || e.clientWidth || g.clientWidth
    //y = w.innerHeight|| e.clientHeight|| g.clientHeight
  return x
}

class HorizontalScroller extends React.PureComponent {
  snapPoints = [];
  onScrollTimeout = null;
  stopAnimationTimeout = null;
  animationTime = 500;
  desktopNumToShow = 4;
  mobileNumToShow = 2;
  mobileBreakPoint = 825; //corresponds with xs breakpoint in css

  constructor(props) {
    super(props)
    this.state = {
      startMousePosition: 0,
      scrollPosition: 0,
      draggingThumb: false,
      scrollParentLeft: 0,
      scrollParentWidth: 0,
      thumbWidth: 0,
      defaultFontSize: 16,
      scrollSnapPointIndex: 0,
      snapPointsLength: 0,
      isAnimating: false,
      isSnapping: false,
      isMobile: false
    }

    this.scrollEvents = [
      'scroll',
      'wheel',
      'DOMMouseScroll',
      'MozMousePixelScroll',
      'touchstart',
      'touchmove',
      'touchend'
    ]

    this.onDragThumb = this.onDragThumb.bind(this)
    this.setThumbStart = this.setThumbStart.bind(this)
    this.dragEndThumb = this.dragEndThumb.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.resize = this.resize.bind(this)
    this.jumpToNearestSnap = this.jumpToNearestSnap.bind(this)
    this.nextThree = this.nextThree.bind(this)
    this.lastThree = this.lastThree.bind(this)
    this.snapToSnapIndex = this.snapToSnapIndex.bind(this)

    this.animate = this.animate.bind(this)
  }

  componentDidMount() {
    this.scrollEvents.forEach(type => {
      this.itemsContainer.addEventListener(type, this.onScroll, false)
    })
    window.addEventListener('resize', this.resize, false)
    this.resize()
  }
  componentWillReceiveProps(nextProps) {
    const { ...thisProps } = this.props
    const { ...nextPropsModified } = nextProps
    if (!isEqual(thisProps, nextPropsModified)) {
      this.setState({ scrollPosition: 0 })
    }
    this.resize()
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.draggingThumb && !prevState.draggingThumb) {
      document.addEventListener('mousemove', this.onDragThumb)
      document.addEventListener('mouseup', this.dragEndThumb)
    } else if (!this.state.draggingThumb && prevState.draggingThumb) {
      document.removeEventListener('mousemove', this.onDragThumb)
      document.removeEventListener('mouseup', this.dragEndThumb)
      this.jumpToNearestSnap()
    }
  }
  componentWillUnmount() {
    document.removeEventListener('mousemove', this.onDragThumb)
    document.removeEventListener('mouseup', this.dragEndThumb)
    this.scrollEvents.forEach(type => {
      this.itemsContainer.removeEventListener(type, this.onScroll, false)
    })
    window.removeEventListener('resize', this.resize, false)
    clearTimeout(this.stopAnimationTimeout)
    clearTimeout(this.onScrollTimeout)
  }

  resize(e) {
    const parentRect = this.thumb.parentElement.getBoundingClientRect()
    const scrollParentLeft = parentRect.left
    const scrollParentWidth = parentRect.width
    const style = window.getComputedStyle(this.thumb.parentElement)
    const defaultFontSize = parseInt(
      style.getPropertyValue('font-size').slice(0, -2)
    )
    const prevMobile = this.state.isMobile

    this.setState({
      thumbWidth: this.thumb.getBoundingClientRect().width,
      scrollParentLeft,
      scrollParentWidth,
      defaultFontSize,
      isMobile: windowWidth() <= this.mobileBreakPoint
    },()=>{
      if (this.state.isMobile && !prevMobile) {
        this.resize()
      }
      this.generateScrollSnapPoints()
    })
  }
  generateScrollSnapPoints() {
    const {
      defaultFontSize,
      thumbWidth,
      scrollParentWidth,
      isMobile
    } = this.state
    const {
      itemsLength,
      gutterWidth,
    } = this.props
    this.snapPoints = [

    ]
    const numToShow = isMobile ? this.mobileNumToShow : this.desktopNumToShow
    const newGutterWidth = isMobile ? gutterWidth/2 : gutterWidth
    if (itemsLength > numToShow) {
      const actualCardWidth = isMobile
        ? scrollParentWidth/numToShow - (newGutterWidth * defaultFontSize)
        : scrollParentWidth/numToShow - (newGutterWidth/(numToShow/(numToShow-1)) * defaultFontSize)

      const scale = x => {
        const a = 0
        const b = scrollParentWidth - thumbWidth
        const min = 0
        const max =
          0 -
          actualCardWidth * (itemsLength-numToShow) -
          newGutterWidth * defaultFontSize * (itemsLength-numToShow)
        return parseFloat((b - a) * (x - min) / (max - min) + a)
      }
      for (let tempScrollPosition = 0; tempScrollPosition < scrollParentWidth - thumbWidth; tempScrollPosition += -scale(actualCardWidth + newGutterWidth * defaultFontSize) * numToShow) {
        this.snapPoints.push(tempScrollPosition)
      }
      this.snapPoints.push(scrollParentWidth - thumbWidth)
    }
    this.setState({
      snapPointsLength: this.snapPoints.length
    })
  }

  setThumbStart(e) {
    if (e.button !== 0) return
    const rect = this.thumb.getBoundingClientRect()
    const left =
      rect.left + document.body.scrollLeft - this.state.scrollParentLeft
    this.setState({
      startMousePosition: e.pageX - left,
      draggingThumb: true
    })
    e.stopPropagation()
    e.preventDefault()
  }
  onDragThumb(e) {
    if (!this.state.draggingThumb) return

    const scrollPosition = Math.min(
      Math.max(0, e.pageX - this.state.startMousePosition),
      this.state.scrollParentWidth - this.state.thumbWidth
    )
    this.setState({
      scrollPosition: scrollPosition
    })
    e.stopPropagation()
    e.preventDefault()
  }
  dragEndThumb(e) {
    this.setState({ draggingThumb: false })
    e.stopPropagation()
    e.preventDefault()
  }

  onScroll(e) {
    const {itemsLength} = this.props
    const {isMobile} = this.state
    const numToShow = isMobile ? this.mobileNumToShow : this.desktopNumToShow
    if (itemsLength > numToShow && !this.state.isSnapping) {
      if (e.type === 'touchstart') {
        this.onTouchStart(e)
      } else if (e.type === 'touchmove') {
        this.onTouchMove(e)
      } else if (e.type === 'touchend') {
        this.onTouchEnd(e)
      } else {
        this.onMouse(e)
      }
    }
  }
  onTouchStart(e) {
    const {isMobile} = this.state
    const numToShow = isMobile ? this.mobileNumToShow : this.desktopNumToShow
    const touch = e.changedTouches[0]
    let scrollPosition = this.state.startMousePosition + touch.pageX/this.props.itemsLength*numToShow

    this.setState({
      startMousePosition: scrollPosition,
      startX: touch.pageX,
      startScroll: getTime(),
      isAnimating: false,
      isDragging: true,
    })
  }
  onTouchMove(e) {
    const {isMobile} = this.state
    const numToShow = isMobile ? this.mobileNumToShow : this.desktopNumToShow
    const touch = e.changedTouches[0]
    const scrollPosition = Math.min(
      Math.max(0, this.state.startMousePosition - touch.pageX/this.props.itemsLength*numToShow),
      this.state.scrollParentWidth - this.state.thumbWidth
    )
    let timeStamp = getTime()
    this.setState({
      scrollPosition: scrollPosition,
    })
    if (timeStamp - this.state.startScroll > 500) {
      this.setState({
        startScroll: timeStamp,
        startX: touch.pageX
      })
    }
    e.preventDefault()
    e.stopPropagation()
  }
  onTouchEnd(e) {
    const handleTouchEnd = () => {
      if (!this.state.isDragging) {
        this.jumpToNearestSnap()
        this.setState({
          startMousePosition: this.state.scrollPosition,
          startX: this.state.scrollPosition
        })
      }
    }

    this.setState({
      isDragging:false,
    })
    const touch = e.changedTouches[0]
    const duration = getTime() - this.state.startScroll
    if (duration < 500) {
      const m = momentum(touch.pageX, this.state.startX, duration, 0.0006)
      this.animate(m.destination, m.duration, handleTouchEnd)
    } else {
      handleTouchEnd()
    }
  }
  onMouse(e) {
    if (e.deltaX) {
      const delta = e.deltaX
      const scrollPosition = Math.min(
        Math.max(0, this.state.scrollPosition + delta),
        this.state.scrollParentWidth - this.state.thumbWidth
      )
      this.setState({
        scrollPosition
      })
      clearTimeout(this.onScrollTimeout)
      this.onScrollTimeout = setTimeout(()=> {
        this.jumpToNearestSnap()
      },500)
      e.stopPropagation()
      e.preventDefault()
    }
  }

  snapToSnapIndex(index) {
    this.setState({
      isSnapping: true
    }, () =>
      this.setState({
        scrollPosition: this.snapPoints[index],
        startMousePosition: this.snapPoints[index],
        scrollSnapPointIndex: index,
      }, ()=>{
        clearTimeout(this.stopAnimationTimeout)
        this.stopAnimationTimeout = setTimeout(()=>{
          this.setState({
            isSnapping: false
          })
        }, this.animationTime)
      }))
  }
  jumpToNearestSnap() {
    const indexOfNearestScroll = indexOfClosest(this.state.scrollPosition, this.snapPoints)
    this.snapToSnapIndex(indexOfNearestScroll)
  }
  nextThree() {
    if (this.state.scrollSnapPointIndex+1 < this.snapPoints.length) {
      this.snapToSnapIndex(this.state.scrollSnapPointIndex+1)
    }
  }
  lastThree() {
    if (this.state.scrollSnapPointIndex-1 > -1) {
      this.snapToSnapIndex(this.state.scrollSnapPointIndex-1)
    }
  }

  animate(destX, duration, cb) {
    let startX = this.state.scrollPosition,
      startMousePosition = this.state.startMousePosition,
      startTime = getTime(),
      destTime = startTime + duration,
      easingFn = (k) => {
        return Math.sqrt( 1 - ( --k * k ) )
      }
    const numToShow = this.state.isMobile ? this.mobileNumToShow : this.desktopNumToShow
    const step = () => {
      //If user has tapped to stop the scrolling
      if (!this.state.isAnimating) {
        cb()
        return
      }
      let now = getTime(),
        newX,
        easing
      if ( now >= destTime) {
        this.setState({
          isAnimating: false
        })
        cb()
        return
      }

      now = ( now - startTime ) / duration
      easing = easingFn(now)

      const destXAdjusted = Math.min(
        Math.max(0, startMousePosition - destX/this.props.itemsLength*numToShow),
        this.state.scrollParentWidth - this.state.thumbWidth
      )
      newX = ( destXAdjusted - startX  ) * easing + startX
      this.setState({
        scrollPosition: newX,
        startMousePosition: newX,
        isAnimating: !(this.state.scrollPosition === 0 || this.state.scrollPosition === this.state.scrollParentWidth - this.state.thumbWidth)
      })
      if (this.state.isAnimating) {
        rAF(step)
      } else {
        cb()
        return
      }
    }

    this.setState({
      isAnimating: true,
    })
    step()
  }

  render() {
    const {
      itemsGenerator,
      itemsLength,
      gutterWidth,
      withColor
    } = this.props
    const {
      scrollPosition,
      defaultFontSize,
      thumbWidth,
      scrollParentWidth,
      isSnapping,
      scrollSnapPointIndex,
      snapPointsLength,
      isMobile
    } = this.state


    const itemStyles = {
      flexBasis: ``,
      width: ``,
      marginRight: ``,
      marginLeft: ''
    }
    const itemsStyle = {
      marginLeft: '',
      transform: '',
      transition: ''
    }
    const scrollerContainerStyle = {
      overflowX: 'initial',
      maxWidth: '100%',
      margin: '',
      padding: ''
    }
    const scrollerStyle = {
      width: '100%',
      maxWidth:'',
      margin: '',
      position: 'relative',
    }

    const numToShow = isMobile ? this.mobileNumToShow : this.desktopNumToShow
    const newGutterWidth = isMobile ? gutterWidth/2 : gutterWidth
    const actualCardWidth = isMobile
      ? scrollParentWidth/numToShow - (newGutterWidth * defaultFontSize)
      : scrollParentWidth/numToShow - (newGutterWidth/(numToShow/(numToShow-1)) * defaultFontSize)

    const scale = x => {
      const min = 0
      const max = scrollParentWidth - thumbWidth
      if (max === 0) {
        //number of elements is 1, just apply the correct margin
        return 0
      }
      const a = 0
      const b =
        0 -
        actualCardWidth * (itemsLength - numToShow) -
        newGutterWidth * defaultFontSize * (itemsLength - numToShow)
      return parseFloat((b - a) * (x - min) / (max - min) + a)
    }

    // itemsStyle.transform = `translate3d(${scale(scrollPosition)}px, 0, 0)`;
    itemsStyle.marginLeft = `${scale(scrollPosition)}px`

    itemStyles.flexBasis = `${actualCardWidth}px`
    itemStyles.width = `${actualCardWidth}px`
    itemStyles.marginRight = `${newGutterWidth}rem`

    scrollerStyle.margin='auto'

    scrollerContainerStyle.overflowX = 'hidden'
    scrollerContainerStyle.margin = 'auto'

    if (isMobile) {
      scrollerContainerStyle.padding = '0 5vw'
      itemStyles.marginRight = `${newGutterWidth/2}rem`
      itemStyles.marginLeft = `${newGutterWidth/2}rem`
    }
    const thumbStyle = {
      width: `${numToShow / itemsLength * 100}%`,
      marginLeft: `${scrollPosition}px`,
      // transform: `translate3d(${scrollPosition}px, 0, 0)`,
      transition: ''
    }

    if (isSnapping) {
      itemsStyle.transition = `margin-left ${this.animationTime/1000}s ease`
      thumbStyle.transition = `margin-left ${this.animationTime/1000}s ease`
      // itemsStyle.transition = `transform ${this.animationTime/1000}s ease`;
      // thumbStyle.transition = `transform ${this.animationTime/1000}s ease`;
    }

    const thumbClassNames = ['horizontal-scroller__thumb']
    if (withColor) {
      thumbClassNames.push(`horizontal-scroller__thumb--${withColor}`)
    }
    return (
      <div className='horizontal-scroller' style={scrollerStyle}>
        {
        // <div className='horizontal-scroller__gradient horizontal-scroller__gradient--left' />
        // <div className='horizontal-scroller__gradient horizontal-scroller__gradient--right' />
        }
        {
          scrollSnapPointIndex > 0
            ? <div className='horizontal-scroller__arrow horizontal-scroller__arrow--left' onClick={this.lastThree}><FontAwesomeIcon icon={['fa', 'angle-left']} /></div>
            : null
        }
        {
          scrollSnapPointIndex < snapPointsLength-1
            ? <div className='horizontal-scroller__arrow horizontal-scroller__arrow--right' onClick={this.nextThree}><FontAwesomeIcon icon={['fa', 'angle-right']} /></div>
            : null
        }
        <div style={scrollerContainerStyle} className="horizontal-scroller__container">
          <div
            style={itemsStyle}
            ref={itemsContainer => {
              this.itemsContainer = itemsContainer
            }}
            className="horizontal-scroller__items"
          >
            {itemsGenerator(itemStyles)}
          </div>
          <div
            ref={scrollerbar => {
              this.scrollerbar = scrollerbar
            }}
            className="horizontal-scroller__bar"
            style={
              itemsLength <= numToShow
                ? {
                  opacity: 0
                }
                : null
            }
          >
            <div
              style={thumbStyle}
              draggable="true"
              onDragStart={this.setThumbStart}
              ref={thumb => {
                this.thumb = thumb
              }}
              className={thumbClassNames.join(' ')}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default HorizontalScroller



// WEBPACK FOOTER //
// ./src/core/components/horizontal-scroller/HorizontalScroller.js